// :cow: Cosmose CONFIDENTIAL :iso:
import { RootState } from '../../core/store/store';
import { createSelector } from '@ngrx/store';
import { State } from './auth.reducer';

export const selectFeature = (state: RootState) => state.auth;

export const selectIsLoading = createSelector(
  selectFeature,
  (state: State) => state.isLoading,
);

export const selectDecodedToken = createSelector(
  selectFeature,
  (state: State) => state.decodedToken,
);

export const selectIsCodeRequired = createSelector(
  selectFeature,
  (state: State) => state.isCodeRequired,
);
